import React from 'react';
import { motion } from 'framer-motion';
import './FloatingShapes.css';

const FloatingShapes = () => {
  const shapes = [
    { id: 1, delay: 0 },
    { id: 2, delay: 2 },
    { id: 3, delay: 4 },
    { id: 4, delay: 6 }
  ];

  const blobs = [
    { id: 1, delay: 0 },
    { id: 2, delay: 10 },
    { id: 3, delay: 5 }
  ];

  return (
    <div className="floating-shapes">
      {shapes.map(shape => (
        <motion.div
          key={shape.id}
          className={`shape shape-${shape.id}`}
          animate={{
            y: [0, -30, 20, 0],
            rotate: [0, 120, 240, 360]
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            delay: shape.delay,
            ease: "easeInOut"
          }}
        />
      ))}
      
      {blobs.map(blob => (
        <motion.div
          key={blob.id}
          className={`blob blob-${blob.id}`}
          animate={{
            x: [0, 30, -20, 0],
            y: [0, -50, 20, 0],
            scale: [1, 1.1, 0.9, 1]
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            delay: blob.delay,
            ease: "easeInOut"
          }}
        />
      ))}
    </div>
  );
};

export default FloatingShapes;